/*********************
 Ranked Intervention Selector Pass: 
 *********************/
import Pass from "../Pass";
import getIntervention from "../../../interventions/interventionFactory";
import { interventionTypes, wcpmPivot } from "../../../constants";
import { getWordMetadata } from "../../../utils/metadataUtils";

export default class RankedInterventionSelectorPass extends Pass {
  constructor(PASS_CONFIGS) {
    super();
    this.label = "PASS_RANKED_INTERVENTION_SELECTOR";

    // Instantiate all interventions, since the ranked intervention selector uses it own pool to select from
    Object.values(interventionTypes).forEach((interventionType) => {
      if (!PASS_CONFIGS.disabledInterventionTypes.includes(interventionType)) {
        super.addIntervention(getIntervention(interventionType));
      }
    });
  }

  run(state) {
    super.resetForNextRun(); // Reset class vars (rationaleLog, runStillValid, and selectedIntervention)

    // Identify valid interventions, based on state
    super.qualifyInterventions(state);

    // Select valid intervention using RankedInterventionSelector
    super.selectValidInterventionByRankedSelector(state);

    let fallbackInterventionType;
    const { wcpm, endOfPhrase } = state;

    if (endOfPhrase && state.gsfWordBank && wcpm >= 50) {
      fallbackInterventionType = interventionTypes.GSF;
    }

    const wordMetadata = getWordMetadata(state.word, state);
    if (
      !fallbackInterventionType &&
      wcpm &&
      wordMetadata &&
      wordMetadata.NPHON
    ) {
      if (
        wcpm < wcpmPivot &&
        wordMetadata.NPHON < 6 &&
        this.getValidInterventions().includes(interventionTypes.soundout1)
      ) {
        fallbackInterventionType = interventionTypes.soundout1;
      }

      const highWCPMFallbackInterventionType = endOfPhrase
        ? interventionTypes.soundout2
        : interventionTypes.phonemeGiveWord;

      if (
        wcpm >= wcpmPivot &&
        wordMetadata.NPHON < 7 &&
        this.getValidInterventions().includes(highWCPMFallbackInterventionType)
      ) {
        fallbackInterventionType = highWCPMFallbackInterventionType;
      }
    }

    if (!fallbackInterventionType) {
      fallbackInterventionType = endOfPhrase
        ? interventionTypes.none
        : interventionTypes.giveword;
    }

    super.setFallbackIntervention(fallbackInterventionType);

    // If the RankedInterventionSelector did not find an intervention, use the failsafe
    if (!this.selectedInterventionType) {
      const logMessage =
        "RankedInterventionSelector did not find an intervention in cluster, using failsafe";
      super.selectIntervention(
        fallbackInterventionType,
        "SELECTION_RULE - " + logMessage
      );
    }

    // Return the selected intervention
    return super.getRunResults();
  }
}
